const PDF_MIME_TYPE = 'application/pdf'

/**
 * Fetches a certificate from its presigned S3 url and hands back the bytes typed as a PDF.
 *
 * Neither end of the pipeline states the type: laas-api uploads certificates without a
 * `ContentType` (`infrastructure/s3_service.py`), the html-pdf-generator lambda does the same, and
 * the presigned url carries no `ResponseContentDisposition` override. What comes back is therefore
 * up to the storage backend - AWS S3 defaults to `binary/octet-stream`, which a browser downloads
 * rather than renders, while the local rustfs infers `application/pdf` from the key. Restating the
 * type here makes the preview behave the same either way, without an api change.
 */
export const fetchCertificatePdf = async (url: string): Promise<Blob> => {
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`Certificate request failed with status ${response.status}`)
  }
  return new Blob([await response.blob()], { type: PDF_MIME_TYPE })
}

/** The download filename users have had since before the redesign; kept byte-for-byte. */
export const certificateFileName = (userFullName: string, obtainedOn: string): string =>
  `Certificates_lawpilots E-Learning_${userFullName}_${obtainedOn}.pdf`
